// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svg-font-color svg > path {
  fill: var(--ifm-font-color-base);
}

.donut-hole {
  overflow-y: unset !important;
}

.queryBuilder {
  min-width: 420px;
}

li.tabs__item {
  white-space: nowrap;
}

/* Styles for when "Use validation" option is selected */
.validateQuery .queryBuilder {
  & .ruleGroup.queryBuilder-invalid {
    /* Color invalid groups */
    background-color: color-mix(in srgb, rebeccapurple, transparent 60%);

    & .ruleGroup-addRule {
      /* Bold the "+ Rule" button if the group has no child rules or groups */
      font-weight: bold !important;
    }

    & > .ruleGroup-body {
      display: block;
    }

    & > .ruleGroup-body::after {
      /* Message to user about empty groups */
      content: "Empty groups are considered invalid. Avoid them by using addRuleToNewGroups.";
      color: white;
    }
  }

  & .rule.queryBuilder-invalid .rule-value {
    /* Purple background for empty text fields */
    background-color: color-mix(in srgb, rebeccapurple, transparent 60%);

    &::placeholder {
      color: color-mix(in srgb, rebeccapurple, black 30%);
    }
  }
}

/* Styles for when "Use validation" option is selected (dark theme variations) */
html[data-theme="dark"]
  .validateQuery
  .queryBuilder
  .rule.queryBuilder-invalid
  .rule-value::placeholder {
  color: color-mix(in srgb, rebeccapurple, white 30%);
}

.tabs-container .tabs-container li {
  font-size: smaller;
  padding: var(--ifm-badge-padding-vertical) var(--ifm-badge-padding-horizontal);
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Configuraciones/styles.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE;IACE,yBAAyB;IACzB,oEAAoE;;IAEpE;MACE,uEAAuE;MACvE,4BAA4B;IAC9B;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,uCAAuC;MACvC,uFAAuF;MACvF,YAAY;IACd;EACF;;EAEA;IACE,4CAA4C;IAC5C,oEAAoE;;IAEpE;MACE,mDAAmD;IACrD;EACF;AACF;;AAEA,gFAAgF;AAChF;;;;;EAKE,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,8EAA8E;AAChF","sourcesContent":[".svg-font-color svg > path {\n  fill: var(--ifm-font-color-base);\n}\n\n.donut-hole {\n  overflow-y: unset !important;\n}\n\n.queryBuilder {\n  min-width: 420px;\n}\n\nli.tabs__item {\n  white-space: nowrap;\n}\n\n/* Styles for when \"Use validation\" option is selected */\n.validateQuery .queryBuilder {\n  & .ruleGroup.queryBuilder-invalid {\n    /* Color invalid groups */\n    background-color: color-mix(in srgb, rebeccapurple, transparent 60%);\n\n    & .ruleGroup-addRule {\n      /* Bold the \"+ Rule\" button if the group has no child rules or groups */\n      font-weight: bold !important;\n    }\n\n    & > .ruleGroup-body {\n      display: block;\n    }\n\n    & > .ruleGroup-body::after {\n      /* Message to user about empty groups */\n      content: \"Empty groups are considered invalid. Avoid them by using addRuleToNewGroups.\";\n      color: white;\n    }\n  }\n\n  & .rule.queryBuilder-invalid .rule-value {\n    /* Purple background for empty text fields */\n    background-color: color-mix(in srgb, rebeccapurple, transparent 60%);\n\n    &::placeholder {\n      color: color-mix(in srgb, rebeccapurple, black 30%);\n    }\n  }\n}\n\n/* Styles for when \"Use validation\" option is selected (dark theme variations) */\nhtml[data-theme=\"dark\"]\n  .validateQuery\n  .queryBuilder\n  .rule.queryBuilder-invalid\n  .rule-value::placeholder {\n  color: color-mix(in srgb, rebeccapurple, white 30%);\n}\n\n.tabs-container .tabs-container li {\n  font-size: smaller;\n  padding: var(--ifm-badge-padding-vertical) var(--ifm-badge-padding-horizontal);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
